import { j as r } from "./kezios-design-system.esm172.js";
import { Card as t, Image as g, Stack as h, Flex as i, Text as a, Rating as j } from "@mantine/core";
import e from "./kezios-design-system.esm206.js";
import { PlayButton as p } from "./kezios-design-system.esm90.js";
import { Spacing as s } from "./kezios-design-system.esm135.js";
const C = ({
  imageSrc: n,
  name: o,
  job: c,
  rating: l,
  content: m,
  onClick: d,
  ...x
}) => /* @__PURE__ */ r.jsxs(
  t,
  {
    maw: 400,
    h: "100%",
    shadow: "sm",
    padding: s.s2,
    radius: s.s6,
    withBorder: !0,
    className: e.root,
    ...x,
    children: [
      /* @__PURE__ */ r.jsxs(t.Section, { className: e.imageContainer, children: [
        /* @__PURE__ */ r.jsx(g, { src: n, height: 250 }),
        /* @__PURE__ */ r.jsx(p, { size: 96, className: e.playButton, onClick: d })
      ] }),
      /* @__PURE__ */ r.jsxs(h, { h: "100%", gap: s.s2, mt: s.s2, children: [
        /* @__PURE__ */ r.jsxs(i, { gap: s.s2, align: "center", children: [
          /* @__PURE__ */ r.jsxs(i, { gap: s.s1, align: "center", children: [
            /* @__PURE__ */ r.jsx(a, { variant: "textLg.semibold", c: "gray.6", children: o }),
            /* @__PURE__ */ r.jsx(a, { variant: "textMd", c: "gray.5", children: c })
          ] }),
          /* @__PURE__ */ r.jsx(j, { readOnly: !0, value: l, color: "yellow.3" })
        ] }),
        /* @__PURE__ */ r.jsx(a, { variant: "textLg.medium", c: "gray.6", children: m })
      ] })
    ]
  }
);
export {
  C as CreatorCard
};
